"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Transition = /*#__PURE__*/_react.default.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_react.default.createElement(_Slide.default, _extends({
    direction: "up",
    ref: ref
  }, props));
});
/**
 * Takes over the entire screen as a modal dialog
 * @param open      True if dialog is visible
 * @param onClose   Function for dismissing the dialog
 * @param children  Child components to render
 */


var FullscreenDialog = function FullscreenDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    fullScreen: true,
    open: open,
    onClose: onClose,
    TransitionComponent: Transition
  }, children);
};

FullscreenDialog.propTypes = {
  open: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  children: _propTypes.default.any
};
var _default = FullscreenDialog;
exports.default = _default;